import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20technology%20background%20with%20flowing%20curved%20lines%20in%20warm%20teal%20green%20and%20coral%20orange%20gradients%2C%20minimalist%20modern%20digital%20art%2C%20soft%20gradient%20blends%2C%20clean%20futuristic%20atmosphere%2C%20no%20text%2C%20smooth%20organic%20shapes%2C%20light%20airy%20composition&width=1800&height=1200&seq=91-hero-bg&orientation=landscape"
        alt="91浏览器背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full mb-8">
          <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
          <span className="text-sm font-medium text-foreground-700">v8.0 全新版本已发布</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight">
          极速安全，畅游无限
        </h1>
        <p className="text-lg md:text-xl text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          91浏览器 —— 一款为移动端深度优化的浏览器，集极速浏览、隐私保护、智能管理于一体，让你的每一次上网都安全流畅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="#download"
            className="px-8 py-4 bg-primary-500 text-background-50 font-heading font-semibold text-lg rounded-xl hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line mr-2"></i>
            免费下载
          </a>
          <Link
            to="/category/usage-tips"
            className="px-8 py-4 bg-background-50/20 backdrop-blur-sm text-background-50 font-heading font-semibold text-lg rounded-xl border border-background-50/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
          {[
            { icon: 'ri-speed-up-line', label: '极速浏览', desc: '页面秒开无等待' },
            { icon: 'ri-shield-check-line', label: '隐私安全', desc: '全方位数据保护' },
            { icon: 'ri-smartphone-line', label: '全平台支持', desc: 'Android / iOS 通用' },
          ].map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-3 px-4 py-3 bg-background-50/10 backdrop-blur-sm rounded-xl border border-background-50/20"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-background-50">{item.label}</p>
                <p className="text-xs text-background-300">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}